import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useDelete = () => {
  const { mutate: deleteUser, isPending } = useAppMutation([QueryKey.PATCH_USER], {
    mutationFn: () => ApiService.delete({ endpoint: BackendRoute.USERS }),
  });
  return { deleteUser, isPending };
};
